window.VH = window.VH === undefined ? {} : window.VH;
VH.ClickUrl = {
    init : function init() {
        VH.Helper.wr.on('click', '.clickUrl a', VH.Helper.onInModalAClick);

        VH.Helper.wr.on('click', '.clickUrl', function () {
            let t = $(this),
                url = t.data('click-url');

            if (url !== undefined && url !== '#' && url !== '') {
                VH.Helper.d[0].location.href = url;
            }
            return false;
        });
    }
};